import styled, { css } from "styled-components"

export const PostDiv = styled.div`
  background: white;
  padding: 32px 80px 36px;

  @media (max-width: 560px) {
    padding: 9px;
  }
`
export const CategoryLabel = styled.div<{
  color?: string
  onClick?: Function
  strong?: boolean
}>`
  color: ${({ color }) => (color ? color : "#b662d3")};
  font-feature-settings: "clig" off, "liga" off;
  font-family: san-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: bold;
  line-height: 12px; /* 100% */
  letter-spacing: 1.28px;
  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `};
  ${({ strong }) =>
    strong &&
    css`
      font-size: 16px;
      line-height: 16px; /* 100% */
    `};
  /* SP style */
  @media screen and (max-width: 767px) {
    font-size: 15px;
  }
`

export const CategoriesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-flow: row wrap;
`

export const CategoryBox = styled.div<{ color?: string }>`
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 6px;
  padding-bottom: 6px;
  background: ${props => props.color || "#042737"};
  color: white;
  cursor: pointer;
`

/*-------------------------------------------*/

export const PostTitle = styled.h1`
  color: var(--Black, #000);
  font-feature-settings: "clig" off, "liga" off;
  font-family: san-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: bold;
  line-height: 150%; /* 60px */
  letter-spacing: 0;
  /* SP style */
  @media screen and (max-width: 767px) {
    color: var(--Dark_Gray, #242424);
    font-size: 26px;
  }
`

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  background: #d8d8d8;
`

export const PostContent = styled.div`
  margin-bottom: 60px;

  h3,
  h4,
  h5,
  h6 {
    line-height: 1.5;
    font-weight: 700;
  }

  h3 {
    font-size: 1.25rem; // 20px
    margin: 2.5rem 0 1rem; // 40px top, 16px bottom
  }

  h4 {
    font-size: 1.125rem; // 18px
    margin: 2rem 0 0.8rem; // 32px top, 12.8px bottom
  }

  h5 {
    font-size: 1rem; // 16px
    margin: 1.5rem 0 0.6rem; // 24px top, 9.6px bottom
  }

  h6 {
    font-size: 0.875rem; // 14px
    margin: 1rem 0 0.5rem; // 16px top, 8px bottom
  }

  strong {
    font-size: inherit;
    font-weight: 700;
  }

  p {
    margin: 28.8px 0 0 0;
    color: var(--Black, #000);
    font-feature-settings: "clig" off, "liga" off;
    font-family: san-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 28.8px; /* 200% */
    letter-spacing: 1.28px;
    /* SP style */
    @media screen and (max-width: 767px) {
      margin: 28.8px 0 0 0;
    }

    span {
      img {
        width: 100% !important;
      }
    }
  }

  figure {
    span {
      width: 100% !important;
    }
  }

  ul {
    list-style: disc;
    margin: 28.8px 0 0 2em;
    li {
      line-height: 2.125rem; //34px;
      word-break: break-all;
    }
    li > ul {
      margin: 0 0 0 2em;
    }
  }

  ol {
    list-style: decimal;
    margin: 28.8px 0 0 2em;
    li {
      // font-size: 1.125rem; // 18px
      line-height: 2.125rem; //34px;
      word-break: break-all;
    }
  }
  b {
    font-weight: bold;
  }

  a {
    color: #1487bd;
    text-decoration: none;

    :visited {
      color: #789dae;
    }
  }

  img {
    margin: 28.8px 0 0 0 !important;
    display: block;
    max-width: 100%;
    height: auto !important;
    margin: 0 auto;
    text-align: center;
    cursor: pointer;
    border: 1px solid #f2f2f2;
  }

  figure {
    text-align: center;

    img {
      height: 100%;
      max-width: 100% !important;
    }
  }
  iframe {
    margin: 28.8px 0 0 0 !important;
  }

  figcaption {
    margin: 20px;
  }

  blockquote {
    background-color: #f5f5f5;
    margin: 28.8px 0 0 0 !important;
    padding: 1.25em 1.5em;
  }

  blockquote > * {
    font-size: 1rem;
    margin-top: 0;
    margin-bottom: 0;
  }

  cite {
    display: block;
    margin-top: 20px;
    font-style: italic;
    font-size: 14px;
  }

  sup,
  sup span {
    vertical-align: super;
    color: #cf2e2e;
    font-size: 0.75rem; /* 75% of 16px */
  }

  code {
    background: #f7f7f7;
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New",
      monospace !important;
    padding: 4px;
    color: #c74747;
    overflow: auto !important;

    * {
      font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New",
        monospace !important;
    }
  }

  pre code {
    display: block;
    padding: 16px;
    line-height: 1.4;
    background: #f7f7f7;
    overflow: scroll;
    font-family: monospace;
    color: black;
  }

  .wp-block-table {
    margin: 2em;

    table {
      width: 100%;
      text-align: left;

      td,
      th {
        padding: 0.5em 0.75em;
        vertical-align: middle;
      }

      tr {
        height: 50px;
      }
    }

    div {
      margin-left: 0;
      margin-right: 0;
    }
  }

  .is-style-stripes {
    tbody tr:nth-child(odd) {
      background-color: #f0f0f0;
    }
  }
`
